import estimateKeys from '@/api/queries/estimates/keyFactory';
import useGetProjectEstimate from '@/api/queries/project/useGetProjectEstimate';
import PriceDetailOptions from '@/ui/components/priceDetailOptions/PriceDetailOptions';
import { useQueryClient } from '@tanstack/react-query';
import { FC } from 'react';

type OptionsTabProps = {
  projectId: string;
  estimateId: string;
};

const OptionsTab: FC<OptionsTabProps> = (props) => {
  const { projectId, estimateId } = props;
  const { project } = useGetProjectEstimate(projectId, estimateId);
  const queryClient = useQueryClient();

  return (
    <PriceDetailOptions
      className="p-4"
      projectId={projectId}
      project={project}
      description="Applies to this project's estimates, proposal and invoices."
      onSaved={() =>
        void queryClient.invalidateQueries({
          queryKey: estimateKeys.estimatePreview(estimateId),
        })
      }
    />
  );
};

export default OptionsTab;
